import isDate from 'lodash/isDate';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.locale('de');
dayjs.extend(relativeTime);
var humanizeDate = function (obj) {
    if (!obj) {
        return '';
    }
    if (isDate(obj)) {
        var date = obj;
        if (isNaN(date.getTime())) {
            return '';
        }
        var theDate = dayjs(obj);
        if (theDate.isBefore(new Date())) {
            return '[' + theDate.toNow() + ']';
        }
        else {
            return '[' + theDate.fromNow() + ']';
        }
    }
    return obj.toString();
};
export default humanizeDate;
